import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShipDarker = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 90 83",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#c1f0e6",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3953 13.3721V5H43.1395V13.3721",
			strokeWidth: 10,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.869 34.4841V20.9535H59.4609L66.2263 34.4841",
			strokeWidth: 10,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.8689 56.7801L12.1036 36.4842H79.7569L69.6089 56.7801",
			strokeWidth: 10,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 63.2326C5 70.9384 11.5127 77.186 19.5455 77.186C25.0655 77.186 29.8091 74.2017 32.2727 69.857C34.7364 74.2017 39.48 77.186 45 77.186C50.52 77.186 55.2636 74.2017 57.7273 69.857C60.1909 74.2017 64.9346 77.186 70.4546 77.186C78.4873 77.186 85 70.9384 85 63.2326",
			strokeWidth: 10,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgShipDarker);
export default ForwardRef;
